export class SystemConst {
  /** 可以接受的判斷式, >, >=, <, <=, =, != */
  static readonly AcceptExpression = '>=<=!=';
}
